/**
 * Canvas Utilities
 * 
 * Helper functions for canvas drawing operations
 * Extracted from App.jsx to improve code organization
 */

/**
 * Clear a canvas element
 * @param {HTMLCanvasElement|null} canvas - Canvas element to clear
 */
export const clearCanvas = (canvas) => {
  if (canvas) {
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
};

/**
 * Clear canvas by ref
 * @param {React.RefObject} canvasRef - Canvas ref object
 */
export const clearCanvasByRef = (canvasRef) => {
  if (canvasRef && canvasRef.current) {
    clearCanvas(canvasRef.current);
  }
};

export default {
  clearCanvas,
  clearCanvasByRef
};

